var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.997 2q-.187 0-.366.07L2.66 8.56l-.14.07c-.54.299-.841.81-.841 1.37l.007.15a1.55 1.55 0 0 0 .897 1.26l6.67 3.335 3.352 6.703.066.126c.264.45.773.747 1.329.747a1.55 1.55 0 0 0 1.409-.904l6.52-18.046A1 1 0 0 0 20.997 2m-3.873 3.462L4.368 10.066l5.434 2.718zm-5.908 8.736 7.32-7.32-4.604 12.75z",
    clipRule: "evenodd"
  })));
};
export default SvgSend;